module.exports = __webpack_public_path__ + "static/media/indo-american.476f0ed2.png";